<template>
  <Breadcrumbs />
  <DynamicContent
    id="brand-overview-content"
    class="container dynamic-content"
    :html="content?.introductionBlock"
  ></DynamicContent>

  <div class="container" :class="{ 'mb-2': !isContentBlockEmpty(content?.introductionBlock) }">
    <BaseTitle>{{ $t("brands.brands-from-a-z") }} </BaseTitle>
    <AlphabetGrid />
  </div>

  <BrandsGrid
    :input="{
      searchFilter,
    }"
    :pagination="{ limit: 15, offset: 0 }"
    :show-load-more="true"
    :title="isContentBlockEmpty(content?.introductionBlock) ? brandsTitle : undefined"
    :tag="'h2'"
    class="mb-4"
  />

  <DynamicContent
    id="brand-overview-content-similar"
    class="container dynamic-content"
    :html="content?.similarBlock"
  ></DynamicContent>

  <DynamicContent
    id="brand-overview-content-timed"
    class="container dynamic-content"
    :html="content?.timedBlock"
  >
  </DynamicContent>
  <DynamicContent
    id="brand-overview-content-offers"
    class="container dynamic-content"
    :html="content?.offersBlock"
  >
  </DynamicContent>

</template>

<script setup lang="ts">
import { useRouteQuery } from "@vueuse/router";
import { SearchFilter, useWebsitePageQuery } from "~/graphql/generated";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/merken",
    fr: "/marques",
    nl: "/merken",
  },
});

const activeChar = useRouteQuery("startsWith", "", {
  transform: String,
});

const searchFilter = computed(
  () => SearchFilter[activeChar.value as keyof typeof SearchFilter],
);

const { t } = useI18n();
const brandsTitle = computed(() => {
  if (activeChar.value)
    return t("brands.brands-starting-with", [activeChar.value]);
  return t("brands.popular-brands");
});

// Set the (optional) page content blocks
const path = useRoute().path;
const { websitePagePath } = useWebsitePagePath(path);
const page = await useWebsitePageQuery({ variables: websitePagePath });
const content = useDynamicContent(page.data);

</script>

<style lang="css">
#brand-overview-content p {
  margin-bottom: 0;
}
</style>
